export default __webpack_public_path__ + "static/media/profileIcon.7f113fd5.svg";